window.addToCart = async function (variantId, quantity = 1, properties = {}) {
  if (!variantId) {
    console.warn('addToCart: Missing variantId');
    return;
  }

  try {
    const payload = {
      items: [
        {
          id: Number(variantId),
          quantity: Number(quantity) || 1,
          properties: properties || {}
        }
      ]
    };

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await res.json();

    if (!res.ok) {
      if (window.globalEvents) {
        window.globalEvents.emit('notice.global', {
          type: 'error',
          content: data.description || 'Unable to add item to cart'
        });
      }

      throw new Error(data.description || 'Failed to add to cart');
    }

    /**
     * Proud Poppy theme add-to-cart flow.
     * This should let the existing cart system refresh/open the drawer.
     */
    if (window.globalEvents) {
      window.globalEvents.emit('cart.add', data);
    } else {
      console.warn('addToCart: globalEvents is missing');
    }

    return data;
  } catch (error) {
    console.error('Add to cart failed:', error);
  }
};

window.openQuickAdd = function ({
  variants = [],
  tags = []
} = {}) {
  if (!window.globalEvents) {
    console.warn('openQuickAdd: globalEvents is missing');
    return;
  }

  if (!Array.isArray(variants) || !variants.length) {
    console.warn('openQuickAdd: Missing variants');
    return;
  }

  /**
   * Proud Poppy native PLP quick-add flow.
   * The PLP product card emits product.quick_add with variants and tags.
   */
  window.globalEvents.emit('product.quick_add', {
    variants,
    tags: Array.isArray(tags) ? tags : []
  });
};